import React, { Component } from 'react';
import {
  Grid,
  TableRow,
  TableCell,
  Typography
} from '@material-ui/core';
import { format } from 'date-fns';
import PropTypes from 'prop-types';

import i18n from '../../i18n';

class ContractSummary extends Component {
  getPositionName = positionId => {
    const { positions } = this.props;
    const match = positions.find(position => position.id === positionId);
    return match ? match.name : positionId;
  }

  mapContractSummary = (contract, index) =>(
    <TableRow key={`contract-summary-${index}`}>
      <TableCell colSpan={2}>
        <Grid container>
          <Grid item>
            <Typography>
              {this.getPositionName(contract.positionId)}
            </Typography>
          </Grid>
          <Grid item>
            <Typography>
              {format(contract.contractStart, 'MMM dd yyyy')}
            </Typography>
          </Grid>
          <Grid item>
            <Typography>
              {format(contract.contractEnd, 'MMM dd yyyy')}
            </Typography>
          </Grid>
        </Grid>
      </TableCell>
    </TableRow>)
  
  render() {
    const { contracts } = this.props;

    return (
      <React.Fragment key='contract-summary'>
        <TableRow>
          <TableCell className="attributeLabel" colSpan={2}>
            {i18n.t('userProfile:contractSummary')}
          </TableCell>
        </TableRow>
        {contracts.map(this.mapContractSummary)}
      </React.Fragment>
    )
  }
}

ContractSummary.propTypes = {
  contracts: PropTypes.arrayOf(PropTypes.object).isRequired,
  positions: PropTypes.arrayOf(PropTypes.object).isRequired
}

export default ContractSummary;